import React from "react";


const BusinessFormField = ({
    label = "",

    required = false,

    error = "",

    helperText = "",

    full = false,

    children,

    className = "",
}) => {

    /*
    |--------------------------------------------------------------------------
    | CLASS NAME
    |--------------------------------------------------------------------------
    */

    const fieldClassName = [
        "platform-business-form-field",

        full
            ? "platform-business-form-field-full"
            : "",

        error
            ? "platform-business-form-field-has-error"
            : "",

        className,
    ]
        .filter(Boolean)
        .join(" ");


    /*
    |--------------------------------------------------------------------------
    | UI
    |--------------------------------------------------------------------------
    */

    return (

        <div
            className={
                fieldClassName
            }
        >

            {/*
            |--------------------------------------------------------------------------
            | LABEL
            |--------------------------------------------------------------------------
            */}

            {label ? (

                <label className="platform-business-form-label">

                    <span>

                        {
                            label
                        }

                    </span>


                    {required ? (

                        <span
                            className="platform-business-required"
                            aria-hidden="true"
                        >

                            *

                        </span>

                    ) : null}

                </label>

            ) : null}


            {/*
            |--------------------------------------------------------------------------
            | INPUT / SELECT / CUSTOM CONTROL
            |--------------------------------------------------------------------------
            */}

            <div className="platform-business-form-control">

                {
                    children
                }

            </div>


            {/*
            |--------------------------------------------------------------------------
            | ERROR
            |--------------------------------------------------------------------------
            */}

            {error ? (

                <small className="platform-business-field-error">

                    {
                        error
                    }

                </small>

            ) : null}


            {/*
            |--------------------------------------------------------------------------
            | HELPER TEXT
            |--------------------------------------------------------------------------
            */}

            {
                !error &&
                helperText
                    ? (

                        <small className="platform-business-field-helper">

                            {
                                helperText
                            }

                        </small>

                    )
                    : null
            }

        </div>

    );

};


export default BusinessFormField;